var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.15147 3.15262C9.32528 2.93804 9.29224 2.62319 9.07766 2.44938C8.86308 2.27557 8.54822 2.30861 8.37441 2.52319L3.61414 8.39998L1.626 6.42494C1.4301 6.23032 1.11352 6.23137 0.918901 6.42727C0.724285 6.62318 0.725331 6.93976 0.921238 7.13438L3.30197 9.49942C3.40229 9.59908 3.54012 9.6516 3.68131 9.64398C3.82251 9.63635 3.95388 9.5693 4.04289 9.45942L9.15147 3.15262ZM13.0814 3.16663C13.263 2.95855 13.2415 2.6427 13.0334 2.46115C12.8253 2.27961 12.5095 2.30111 12.3279 2.50919L7.17358 8.41667L6.74794 7.99934C6.55077 7.80601 6.2342 7.80912 6.04087 8.0063C5.84754 8.20348 5.85066 8.52004 6.04783 8.71337L6.85187 9.50172C6.95016 9.59809 7.08383 9.64968 7.22138 9.64433C7.35892 9.63897 7.48818 9.57715 7.57868 9.47343L13.0814 3.16663Z",
    fill: "#9C9CA3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageRead);
export default __webpack_public_path__ + "static/media/message-read.72b12f5871e80ed6dd403988dd99de3c.svg";
export { ForwardRef as ReactComponent };